var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchAccessory"},_vm._l((_vm.washProductAccessoryList),function(item,index){return _c('div',{key:index,staticClass:"accessory-item",on:{"click":function($event){return _vm.onAccessory(item)}}},[_vm._v("\n        "+_vm._s(item.accessoryName)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }